import { nonStandardKeys, IDictionaryRate } from '@/queries/fetchRates';

export const getRepaymentCalculatorRates = (rates: IDictionaryRate) => ({
  selectRates: rates[nonStandardKeys.SELECT],
  backbookRates: rates[nonStandardKeys.BACK_BOOK],
  frontbookRates: rates[nonStandardKeys.FRONT_BOOK],
  directBasicsRates: rates[nonStandardKeys.DIRECT_BASICS],
  directExtrasRates: rates[nonStandardKeys.DIRECT_EXTRAS],
});
